/*jshint esversion: 6 */
/*jshint sub:true*/
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify'

const initialState = () => ({
  takt_time_filter: {
    active: false,
    start: 5,
    end: 11
  },
  multiproject_skip_weekends: false,
  account_info_edit_mode: false,
  account_settings_status: '',
  dialog_new_project_show: false,
  show_ifc_import_dialog: false,
  show_ifc_filter_dialog: false,
  show_wp_status_multiproject: false,
  taktarea_dragging: false,
  use_intersection_observer: true,
  show_taktplan: true,
  login_show: true,
  project_members_selected_index: 0,
  register_show: true,
  isLightTheme: localStorage.getItem('is_light_theme'),
  taktplan_zoom: localStorage.getItem('taktplan_zoom') ? parseFloat(localStorage.getItem('taktplan_zoom')) : 1.1,
  multiproject_taktplan_zoom: localStorage.getItem('multiproject_taktplan_zoom') ? parseFloat(localStorage.getItem('multiproject_taktplan_zoom')) : 0.2,
  temp_user_email: '',
  show_side_bar: false,
  show_own_wps: false,
  meta_data: { offset: 0, limit: 0, total: 0 },
  show_milestones: false,
  statistics_height_variables: {statistics_height: 300},
  project_location_edit: false,
  application_popup_dialog: false,
  taktarea_filter: '',
  register_as_invited_feedback: { state: 'init', payload: '' },
  snack_bar: {
    show: false,
    check_old_value: false,
  },
  mobile_wallet_show_settings: false,
  wallet_workpackage_header_items: ['token'],
  wallet_show_workpackages: true,
  wallet_show_workpackages_cache: true,
  selected_project_data_index: 0,
  project_data_editing: '',
  spatial_view: false,
  current_project_socket_data: { users: [], editor: false },
  isMacroView: false,
  isMicroView: false,
  isShowMicroGrid: false,
  microlevel_taktarea_filter: [],
  new_substep_step_id: -1,
  new_substep_step_type: false,
  new_substep_search_step_id: false,
  isTokenView: false,
  isMPStatusView: false,
  multiproject_flexbar_color_mode: false,
  backglogs_show_with_date: localStorage.getItem('backglogs_show_with_date') || false,
  user_feedback: {
    show: false,
    msg: 'Test Message'
  },
  loading_project_overview: true,
  multiproject_flexbar_visible: false,
  is_printing_mode: false,
  is_printing_mode_loading: false,
  open_tooltip_index: 0,
  on_site: true,
  is_show_language_popup: false,
  is_taktplan_grid_column: false,
  is_taktplan_grid_row: false,
  is_taktplan_takttime_highlight: true,
  is_taktplan_milestone_highlight: false,
  is_taktplan_train_seperator: false,
  is_taktplan_legend: false,
  is_taktplan_legend_left: false,
  is_taktplan_legend_left_rotated: false,
  is_taktplan_legend_milestones: false,
  is_taktplan_show_only_filtered_workpackages: false,
  is_taktplan_taktarea_description: false,
  is_print_background_color: true,
  is_print_worksteps: true,
  is_print_manpower: true,
  is_print_cutting_line: true,
  is_taktplan_timestamp: true,
  font_color_settings: {
    source: 'workpackage'
  },
  is_project_overview_show_terminated: false,
  is_project_overview_show_company_only: false,
  show_snowflakes: true,
  show_taktplan_shadows: true,
  workbench_sorting: 'Updated date (asc)',
  project_structure_create_dialog: {
    show: false,
    object: {}
  },
  
  // multiWindow with LocalStorage
  // multiWindow: {
  //   isActivated: false,
  //   active_element: {
  //     type: 'testtype', 
  //     id: 123,
  //     source: 'testsource',
  //     project_id: 1234,
  //   },
  //   windowData: []
  // },
  localStorageMultiWindowUpdated: false,
});

// State object
const state = initialState();
// Getter functions
const getters = {
  account_info_edit_mode: (state) => state.account_info_edit_mode,
  account_settings_status: (state) => state.account_settings_status,
  getAccountSettingsStatus: (state) => state.account_settings_status,
  getLoginShow: (state) => state.login_show,
  getProjectMembersSelectedIndex: (state) => state.project_members_selected_index,
  getRegisterShow: ( state ) => state.register_show,
  getSnackBar: (state) => state.snack_bar,
  getTaktplanZoom: (state) => state.taktplan_zoom,
  getTempUserEmail: (state) => state.temp_user_email,
  get_dialog_new_project_show: (state) => state.dialog_new_project_show,
  get_application_popup_dialog: (state) => state.application_popup_dialog,
  isAccountInfoEditMode: (state) => state.account_info_edit_mode,
  getRegisterAsInvitedFeedback: (state) => state.register_as_invited_feedback,
  isLightTheme: (state) => state.register_show,
  isShowMilestones: (state) => state.show_milestones,
  is_show_side_bar: (state) => state.show_side_bar,
  isShowOwnWps: (state) => state.show_own_wps,
  is_project_location_edit: (state) => state.project_location_edit,
  getStatisticsHeightVariables: (state) => {
    return state.statistics_height_variables;
  },
  isMobileWalletShowSettings: (state) => state.mobile_wallet_show_settings,
  getWalletWorkpackageHeaderItems: (state) => state.wallet_workpackage_header_items,
  isWalletShowWorkpackages:  (state) => state.wallet_show_workpackages,
  getSelectedProjectDataIndex: (state) => state.selected_project_data_index,
  getProjectDataEditing: (state) => state.project_data_editing,
  isSpatialView: (state) => state.spatial_view,
  getCurrentProjectActiveUsers: (state) => state.current_project_socket_data.users,
  getCurrentProjectActiveEditor: (state) => state.current_project_socket_data.editor,
  isSvgIcon: (state, getters, rootState) => (icon) => {
    return rootState.Ultra.svg_icons.includes(icon);
  },
  isTaktplanShowOnlyFilteredWorkpackages: (state) => state.is_taktplan_show_only_filtered_workpackages,
  isMobile: () => { return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); },
  isLoadingProjectOverview: (state) => state.loading_project_overview,
  // TODO: make vuetify smAndDown work somehow
  getUseOnSite: () => {
    if (state.on_site && Vuetify.framework.breakpoint.smAndDown) {
      return true;
    } else {
      return false;
    }
  },
  getLocalDate:  () => (datestring) => {
    const date = new Date(datestring);
    // get local time zone offset
    const offset = date.getTimezoneOffset();
    return `${date.toISOString().split('T')[0]} ${date.toTimeString().split(' ')[0]} UTC${offset > 0 ? '-' : '+'}${Math.abs(offset / 60)}`;
  },
};
// Actions
const actions = {
  setValue({commit}, payload){
    commit('set_value', payload);
  },
  setAccountInfoEditMode({commit}, edit_mode){
    commit('account_info_edit_mode', edit_mode);
  },
  setAccountSettingsStatus({commit}, status){
    commit('account_settings_status', status);
  },
  setDialogNewProjectShow({commit}, boolean){
    commit('set_dialog_new_project_show', boolean);
  },
  setIsLigthTheme({commit}, boolean){
    commit('set_is_light_theme', boolean);
  },
  setProjectMembersSelectedIndex({commit}, index){
    commit('set_project_members_selected_index', index);
  },
  setRegisterShow({commit}, boolean){
    commit('set_register_show', boolean);
  },
  openSnackBar({commit}, payload) {
    commit('open_snack_bar', payload);
  },
  setSnackBarCheckOldValue({commit}, boolean) {
    commit('set_snack_bar_check_old_value', boolean);
  },
  closeSnackBar({commit}) {
    commit('close_snack_bar');
  },
  setStatisticsHeightVariables({commit}, payload) {
    commit('set_statistics_height_variables', payload);
  },
  setLoginShow({commit}, boolean){
    commit('set_login_show', boolean);
  },
  setShowSideBar({commit}, boolean) {
    commit('set_show_side_bar', boolean);
  },
  setShowMilestones({commit}, boolean) {
    commit('set_show_milestones', boolean);
  },
  setShowOwnWps({commit}, boolean) {
    commit('set_show_own_wps', boolean);
  },
  setTaktplanZoom({commit}, zoom) {
    localStorage.setItem('taktplan_zoom', zoom);
    commit('set_taktplan_zoom', zoom);
  },
  setTempUserEmail({commit}, email){
    commit('set_temp_user_email', email);
  },
  setProjectLocationEdit({commit}, edit){
    commit('set_project_location_edit', edit);
  },
  setApplicationPopupDialog({commit}, dialog){
    commit('set_application_popup_dialog', dialog);
  },
  setWalletWorkpackageHeaderItems({commit}, item) {
    commit('set_wallet_workpackage_header_items', item);
  },
  setWalletShowWorkpackages({commit}, boolean) {
    commit('set_wallet__show_workpackages', boolean);
  },
  setSelectedProjectDataIndex({commit}, item) {
    commit('set_selected_project_data_index', item);
  },
  setProjectDataEditing({commit}, item) {
    commit('set_project_data_editing', item);
  },
  setCurrentProjectSocketData({commit}, item) {
    commit('current_project_socket_data', item);
  },
  setUserFeedback({commit}, message){
    commit('set_user_feedback', message);
  },
  setMacroView({commit}, payload){
    commit('set_macro_view', payload);
  },
  setTokenView({commit}, payload){
    commit('set_token_view', payload);
  },
  //mobile
  setMobileWalletShowSettings({commit}, boolean) {
    commit('set_mobile_wallet_show_settings', boolean);
  },
  setSpatialView({commit}, boolean) {
    commit('set_spatial_view', boolean);
  },
  toggleTaktplanMilestonesView({commit, rootState}, payload) {
    commit('toggle_taktplan_milestones_view', {rootState, payload});
  },
  setLoadingProjectOverview({commit}, payload) {
    commit('set_loading_project_overview', payload);
  },
  increaseOpenTooltipIndex({commit}) {
    commit('increase_open_tooltip_index');
  },
  setShowLanguagePopUp({commit}, payload) {
    commit('set_show_language_popup', payload);
  },
  setMicroView({commit, dispatch, rootGetters}, payload) {
    commit('set_value', {key: 'isMicroView', value: payload.value});
    if(payload.value) {
      commit('set_value', {key: 'wallet_show_workpackages_cache', value: state.wallet_show_workpackages});
      commit('set_value', {key: 'wallet_show_workpackages', value: false});
      dispatch('ProjectWallet/setWalletSettingsCache', {},{root: true});
      dispatch('ProjectWallet/setWalletSettings', {setting: 'taktareas', value: rootGetters['Project/getProjectTaktareas'](payload.project_id)[0]}, {root: true})
      dispatch('Project/requestMicroLevel', {project_id: payload.project_id, takt_index: payload.takt_index}, {root: true})
    } else {
      commit('set_value', {key: 'wallet_show_workpackages', value: state.wallet_show_workpackages_cache});
      dispatch('ProjectWallet/resetWalletSettingsCache', {},{root: true})
    }
  }
};
// Mutations
const mutations = {
  set_value(state, payload){
    // state[payload.key] = payload.value;
    Vue.set(state, payload.key, payload.value);
  },
  account_info_edit_mode(state, edit_mode){
    state.account_info_edit_mode = edit_mode;
  },
  account_settings_status(state, status){
    state.account_settings_status = status;
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_dialog_new_project_show(state, boolean) {
    state.dialog_new_project_show = boolean;
  },
  set_is_light_theme(state, boolean) {
    localStorage.setItem('is_light_theme', boolean);
  },
  set_login_show(state, boolean) {
    state.login_show = boolean;
  },
  set_project_members_selected_index(state, index) {
    state.project_members_selected_index = index;
  },
  set_register_show(state, boolean) {
    state.register_show = boolean;
  },
  set_show_milestones(state, boolean) {
    state.show_milestones = boolean;
  },
  set_show_side_bar(state, boolean) {
    state.show_side_bar = boolean;
  },
  set_show_own_wps(state, boolean) {
    state.show_own_wps = boolean;
  },
  open_snack_bar(state, payload) {
    state.snack_bar = payload;
  },
  set_snack_bar_check_old_value(state, boolean) {
    state.snack_bar.check_old_value = boolean;
  },
  close_snack_bar(state) {
    state.snack_bar = {
      show: false,
      target: {
        id: -1,
        type: '',
      }
    };
  },
  set_statistics_height_variables(state, payload) {
    state.statistics_height_variables = Object.assign({}, state.statistics_height_variables, payload);
  },
  set_taktplan_zoom(state, zoom) {
    state.taktplan_zoom = zoom;
  },
  set_temp_user_email(state, email) {
    state.temp_user_email = email;
  },
  set_project_location_edit(state, edit) {
    state.project_location_edit = edit;
  },
  set_application_popup_dialog(state, dialog) {
    state.application_popup_dialog = dialog;
  },
  set_register_as_invited_feedback(state, feedback){
    Vue.set(state.register_as_invited_feedback, 'state', feedback.state);
    Vue.set(state.register_as_invited_feedback, 'payload', feedback.payload);
  },
  set_wallet_workpackage_header_items(state, item) {
    let items = state.wallet_workpackage_header_items;
    if (items.includes(item)) {
      items.splice(items.indexOf(item), 1);
    } else {
      items.push(item);
    }
  },
  set_wallet__show_workpackages(state, boolean){
    state.wallet_show_workpackages = boolean;
  },
  set_selected_project_data_index(state, item){
    state.selected_project_data_index = item;
  },
  set_project_data_editing(state, item){
    state.project_data_editing = item;
  },
  set_spatial_view(state, boolean) {
    state.spatial_view = boolean;
  },
  toggle_taktplan_milestones_view(state, {rootState, payload}) {
    rootState.Ultra.projects[payload.project_id].showMilestones = !rootState.Ultra.projects[payload.project_id].showMilestones;
  },
  current_project_socket_data(state, data) {
    state.current_project_socket_data = data;
  },
  dismiss_user_feedback(state){
    state.user_feedback.show = false;
  },
  set_user_feedback(state, message){
    state.user_feedback.show = true;
    state.user_feedback.msg = message;
  },
  set_meta_data(state, meta_data){
    state.meta_data = meta_data;
  },
  set_macro_view(state, payload){
    state.isMacroView = payload;
  },
  set_token_view(state, payload){
    state.isTokenView = payload;
  },
  //mobile
  set_mobile_wallet_show_settings(state, boolean) {
    state.mobile_wallet_show_settings = boolean;
  },
  set_loading_project_overview(state, payload) {
    state.loading_project_overview = payload;
  },
  increase_open_tooltip_index(state) {
    state.open_tooltip_index++;
  },
  set_show_language_popup(state, payload) {
    state.is_show_language_popup = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
